import script from "./RewardsStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./RewardsStore.vue?vue&type=script&setup=true&lang=ts"

import "./RewardsStore.vue?vue&type=style&index=0&id=1ba073f9&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ba073f9"]])

export default __exports__